module.exports = __webpack_public_path__ + "img/UNH.1f524a9b.png";